/**
 * Get the API endpoint.
 *
 * If defined in src/config.json, key apiEndpoint, that one is used. If not,
 * current URL is used.
 *
 * @return {string} - The API endpoint URL to use.
 */
export function getApiEndpoint() {
  try {
    var config = require('../config.json');
    if (config.apiEndpoint !== undefined) {
      return config.apiEndpoint;
    }
    throw new Error("API endpoint not defined in config.");
  } catch (ex) {
    if (process.env.REACT_APP_API_ENDPOINT) {
      return process.env.REACT_APP_API_ENDPOINT;
    }
    return window.location.protocol + '//' +  window.location.hostname + (window.location.port ? ':' + window.location.port : '');
  }
}



// WEBPACK FOOTER //
// ./src/utility/config.js